import React from "react"
import { Helmet } from "react-helmet"

import { Form } from "../components/Form"

const IndexPage = () => (
  <>
    <Helmet>
      <title>Contact | au et chiu Import Export</title>
      <link rel="canonical" href="https://auetchiu.com" />
    </Helmet>
    <div className="o-section o-grid">
      <div className="o-grid__item--wide">
        <h1 className="c-heading c-text--green c-text--centered">Have any questions, or want to get in touch?</h1>
        <Form />
      </div>
    </div>
  </>
)

export default IndexPage
